import {
  replaceSocialLink,
  fetchSocialLink,
} from "../../firebase/FirebaseFunctions";
import { useState } from "react";
import {
  instagramLinkType,
  spotifyLinkType,
  instagramLink,
  spotifyLink,
} from "../../firebase/models";
import instagramImg from "../../imgs/companyLogos/instalogo.png";
import spotifyImg from "../../imgs/companyLogos/spotlogo.png";
import { useEffect } from "react";
export default function InstagramAndSpotifyLinkEntry() {
  const [instagramLinkState, setInstagramLinkState] = useState("");
  const [spotifyLinkState, setSpotifyLinkState] = useState("");

  const [instagramTest, setInstagramTest] = useState<instagramLinkType[]>([]);
  const [spotifyLinkTest, setSpotifyLinkTest] = useState<spotifyLinkType[]>([]);
  useEffect(() => {
    const loadData = async () => {
      const [instagramLinks, spotifyLinks] = await Promise.all([
        fetchSocialLink<instagramLinkType>("groupMe"),
        fetchSocialLink<spotifyLinkType>("spotify"),
      ]);

      setInstagramTest(instagramLinks);
      setSpotifyLinkTest(spotifyLinks);
    };

    loadData();
  }, []);

  const handleInstagram = async (e: React.FormEvent) => {
    e.preventDefault();
    const newInstagramLink = new instagramLink(instagramLinkState);
    await replaceSocialLink("instagram", [newInstagramLink]);
    // setInterestFormTest(interestFormLink);
    setInstagramLinkState("");
  };

  const handleSpotify = async (e: React.FormEvent) => {
    e.preventDefault();
    const newSpotifyLink = new spotifyLink(spotifyLinkState);
    await replaceSocialLink("spotify", [newSpotifyLink]);
    setSpotifyLinkState("");
  };

  return (
    <>
      <div className="faq">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          {/* Interest Form Section */}
          <div style={{ flex: "1", minWidth: "300px", maxWidth: "500px" }}>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              REPLACE INSTAGRAM LINK
              <a
                href={instagramTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={instagramImg}
                  style={{ width: 40, marginLeft: 10 }}
                  alt="Instagram Img"
                />
              </a>
            </h3>
            <form onSubmit={handleInstagram}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <input
                  type="text"
                  placeholder="MTC Instagram Account Link"
                  value={instagramLinkState}
                  onChange={(e) => setInstagramLinkState(e.target.value)}
                  required
                  style={{ padding: 10, margin: 10, width: "100%" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <button
                  type="submit"
                  style={{
                    padding: 15,
                    backgroundColor: "lightgray",
                    borderRadius: 100,
                    borderWidth: 0,
                  }}
                >
                  REPLACE INSTAGRAM ACCOUNT LINK
                </button>
              </div>
            </form>
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <a
                href={instagramTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h5>
                  Current Instagram Account Link (stored in DB and on website)
                </h5>
              </a>
            </div>
          </div>

          {/* GroupMe Section */}
          <div style={{ flex: "1", minWidth: "300px", maxWidth: "500px" }}>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              REPLACE SPOTIFY ACCOUNT LINK
              <a
                href={spotifyLinkTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={spotifyImg}
                  style={{ width: 40, marginLeft: 5 }}
                  alt="GroupMe"
                />
              </a>
            </h3>
            <form onSubmit={handleSpotify}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <input
                  type="text"
                  placeholder="MTC Spotify Account Link"
                  value={spotifyLinkState}
                  onChange={(e) => setSpotifyLinkState(e.target.value)}
                  required
                  style={{ padding: 10, margin: 10, width: "100%" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <button
                  type="submit"
                  style={{
                    padding: 15,
                    backgroundColor: "lightgray",
                    borderRadius: 100,
                    borderWidth: 0,
                  }}
                >
                  REPLACE SPOTIFY ACCOUNT LINK
                </button>
              </div>
            </form>
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <a
                href={spotifyLinkTest[0]?.link ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h5>
                  Current Spotify Account Link (stored in DB and on website)
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
